import React from 'react';
import { theme } from 'antd';

const { useToken } = theme;

const ArrowIcon = ({ color, ...rest }: { color?: string; className?: string; [x: string]: unknown }) => {
  const { token } = useToken();
  const currentColor = color ?? token.colorText;
  return (
    <svg viewBox="0 0 8 6" version="1.1" xmlns="http://www.w3.org/2000/svg" {...rest}>
      <g id="MVP" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="Main-assets" transform="translate(-1418.000000, -588.000000)" fill={currentColor}>
          <g id="Group" transform="translate(1416.000000, 585.000000)">
            <g id="-g-Group" transform="translate(2.000000, 3.000000)">
              <polygon id="Triangle-Copy-4" points="4 0 8 6 0 6" />
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default ArrowIcon;
